export const API = process.env.REACT_APP_BACKEND_URL;

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : null))
      .filter(Boolean)
      .join(", ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function api(path, options = {}, allowRetry = true) {
  const res = await fetch(`${API}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  if (res.status === 401 && allowRetry && !path.startsWith("/api/auth/")) {
    const r = await fetch(`${API}/api/auth/refresh`, {
      method: "POST",
      credentials: "include",
    });
    if (r.ok) return api(path, options, false);
  }
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) throw new Error(formatApiError(data?.detail ?? data));
  return data;
}

export async function apiForm(path, formData, allowRetry = true) {
  const res = await fetch(`${API}${path}`, {
    credentials: "include",
    method: "POST",
    body: formData,
  });
  if (res.status === 401 && allowRetry) {
    const r = await fetch(`${API}/api/auth/refresh`, {
      method: "POST",
      credentials: "include",
    });
    if (r.ok) return apiForm(path, formData, false);
  }
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) throw new Error(formatApiError(data?.detail ?? data));
  return data;
}
